import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, SimpleGrid, Stack, Title } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicHomePage: React.FC = () => {
    const { t } = useTranslation();
    const { isAuthenticated } = useAuth();
    const animatedTitle = 'Bienestar estudiantil';
    const tileTarget = isAuthenticated ? '/jobs' : '/login';
    return (
        <div className="home-tiles-wrap">
            <div className="home-tiles-header">
                <div
                    className="home-tiles-title"
                    aria-label={animatedTitle}
                    style={{ ['--title-chars' as any]: animatedTitle.length }}
                >
                    <span className="home-tiles-title__text">{animatedTitle}</span>
                </div>
            </div>
            <SimpleGrid cols={{ base: 1, md: 2 }} spacing="xl" className="home-tiles-grid">
                <Card
                    withBorder
                    padding="xl"
                    radius="lg"
                    shadow="sm"
                    className="home-tile"
                    style={{ ['--tile-image' as any]: "url('/OIG4.jpeg')" }}
                    component={Link}
                    to={tileTarget}
                >
                    <Stack gap="sm" className="home-tile__content">
                        <Title order={2}>{t('publicHome.seekerTitle')}</Title>
                    </Stack>
                </Card>
                <Card
                    withBorder
                    padding="xl"
                    radius="lg"
                    shadow="sm"
                    className="home-tile"
                    style={{ ['--tile-image' as any]: "url('/psico-03-720x720.jpg')" }}
                    component={Link}
                    to={tileTarget}
                >
                    <Stack gap="sm" className="home-tile__content">
                        <Title order={2}>{t('publicHome.posterTitle')}</Title>
                    </Stack>
                </Card>
            </SimpleGrid>
        </div>
    );
};

export default PublicHomePage;
